<template>
    <div class="work-phone-detail">
        <div class="content">
            <div class="data-title">
                <div class="title-name">查看/编辑工作手机号</div>
            </div>
            <template v-if="hasPermission===1">
                <div class="text">基本信息</div>
                <div class="forms">
                    <el-form :inline="true" :model="form" ref="form" :rules="rules" class="form" size="small" label-width="96px">
                        <el-form-item label="工作手机号" prop="phone">
                            <div class="input-con"  v-if="permission.copy">
                                <el-input v-model="form.phone" class="input" placeholder="请输入"  maxlength="11" clearable show-word-limit :disabled="!permission.edit"></el-input>
                                <div v-if="form.phone" class="btn-copy" @click="onCopy(form.phone)">复制</div>
                                <div v-else class="btn-copy btn-copy-dis" >复制</div>
                            </div>
                            <el-input v-else v-model="form.phone" class="input" placeholder="请输入"  maxlength="11" clearable show-word-limit :disabled="!permission.edit"></el-input>
                        </el-form-item>
                        <el-form-item label="运营商" prop="phoneOperator">
                            <el-select v-if="dictionaries.phone_operator" v-model="form.phoneOperator" placeholder="请选择" :disabled="!permission.edit">
                                <el-option v-for="item in dictionaries.phone_operator" :key="item.dictId" :label="item.dictName"
                                    :value="item.dictId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="实名人" class="t-label" prop="name">
                            <el-input v-model="form.name" placeholder="请输入" clearable maxlength="30"
                                type="textarea" style="width: 204px;" rows="3" show-word-limit :disabled="!permission.edit"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号备注" class="t-label" prop="remarks">
                            <el-input v-model="form.remarks" placeholder="请输入" clearable maxlength="64" type="textarea"
                                style="width: 204px;" rows="3" show-word-limit :disabled="!permission.edit"></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="line"></div>
                    <p>更多信息</p>
                    <el-form :inline="true" class="form-list" size="small" label-width="96px">
                        <el-form-item label="创建时间："><div class="con">{{ form.createdTime || '-' }}</div></el-form-item>
                        <el-form-item label="创建人："><div class="con">{{ form.createdByName || '-' }}</div></el-form-item>
                        <el-form-item label="手机号状态：">
                            <div class="con">
                                <span v-if="form.statusLabel" :class="'icon-status icon-status-' + form.status"> {{ form.statusLabel}}</span>
                            </div>
                        </el-form-item>
                        <el-form-item label="最后归属人："><div class="con">{{ form.ownerUserName || '-' }}</div></el-form-item>
                        <el-form-item label="更新时间："><div class="con">{{ form.updatedTime || '-' }}</div></el-form-item>
                        <el-form-item label="最近更新人："><div class="con">{{ form.updatedByName || '-' }}</div></el-form-item>
                        <el-form-item label="最后归属部门：">
                            <template #label>
                                <div class="custom-label">最后&nbsp;&nbsp;&nbsp;<br />归属部门：</div>
                            </template>
                            <div class="con">{{ form.ownerDeptName || '-' }}</div></el-form-item>
                        <el-form-item v-if="form.status==3 && form.cancelReason" label="注销原因："><div class="con">{{ form.cancelReason }}</div></el-form-item>
                        <el-form-item label="历史记录：" v-if="permission.history"><div class="con"><el-button type="primary" class="btn-look" @click="onHistory" plain size="mini">查看</el-button></div></el-form-item>
                    </el-form>

                </div>
            </template>
            <div v-else-if="hasPermission===0" class="no-permission">
                <div class="pic"></div>
                <div class="word">抱歉，您缺少权限</div>
            </div>
            <div class="footer" :class="[isCollapsed ? 'footer-collapsed' : '']">
                <el-button type="info"  plain @click="onBack">返回</el-button>
                <!-- 归属人按钮 -->
                <template v-if="btnShow">
                    <el-button v-if="permission.delete" type="danger" @click="onDelete" :loading="btnDelete">删除</el-button>
                    <el-button v-if="permission.cancel" type="danger" @click="onCancel" :loading="btnCancel">注销账号</el-button>
                    <el-button v-if="permission.revoke" type="info" plain @click="onRevoke" :loading="btnRevoke">撤销</el-button>
                    <el-button v-if="permission.transfer" type="primary" @click="onTransfer" :loading="btnTransfer">转移</el-button>
                    <el-button v-if="permission.edit" type="primary" @click="onSave" :loading="btnSave">保存</el-button>
                </template>
                <!-- 审批人按钮 -->
                 <!-- <el-button type="primary" @click="onApprove" :loading="btnApprove">审批</el-button> -->
            </div>
        </div>
        <org-picker title="转移" :multiple="false" ref="orgPicker" @ok="selected" />
        <pop-report ref="popReport" :reportList="reportList" />
        <pop-cancel ref="popCancel" title="是否确认注销该工作手机号？" @setCancel="setCancel" />
        <pop-revoke ref="popRevoke" title="是否确认撤销该工作手机号？" @setRevoke="setRevoke" />
        <pop-delete ref="popDelete" title="是否确认删除？" @setDelete="setDelete" />
        <pop-approve ref="popApprove" title="审核" @setApprove="setApprove" />
        <pop-history ref="popHistory" title="历史记录" />
    </div>
</template>
<script>
import popApprove from "@/pages/assetManagement/common/popApprove";
import popHistory from "@/pages/assetManagement/common/popHistory";
import workPhoneMixins from '@/pages/assetManagement/common/mixins/workPhone'
import { REGEX } from '@/pages/assetManagement/common/consts/regex.js';
export default {
    name: "workPhoneDetail",
    mixins: [workPhoneMixins],
    components: {popApprove,popHistory},
        computed: {
        isCollapsed() {
            return this.$store.state.isCollapsed
        }
    },
    data() {
        return {
            hasPermission:NaN,
            form: {
                phone: '',
                phoneOperator: '',
                name: '',
                remarks: '',
            },
            permission:{},
            dictionaries: { // 字典数据
                phone_operator: [],
            },
            rules: {
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: REGEX.PHONE, message: '请输入11位手机号', trigger: ['blur','change'] }
                ],
                phoneOperator: [
                    { required: true, message: '请选择手机运营商', trigger: 'blur' }
                ],
            },
            selectIds:[],
            btnDelete:false,
            btnRevoke:false,
            btnCancel:false,
            btnTransfer:false,
            btnSave:false,
            btnApprove:false,
            btnShow:false
        }
    },
    activated() {
        this.fetchData()
        this.selectIds[0] = this.$route.query.id
        this.$refs.form && this.$refs.form.clearValidate()
    },
    created() {
        for(const type in this.dictionaries){
            this.getDictionaries(type)
        }
    },
    methods: {
        onBack() {
            if (this.$route.query.back) {
                let backMenuIndex = localStorage.getItem('backMenuIndex')
                if (backMenuIndex) {
                   localStorage.removeItem('backMenuIndex')
                   localStorage.setItem('selectedMenuIndex',backMenuIndex); 
                }
            }
            this.$router.go(-1);
        },
        onDelete() {
            this.$refs.popDelete.show()
        },
        onCancel() {
            this.$refs.popCancel.show()
        },
        onRevoke() {
            this.$refs.popRevoke.show()
        },
        onTransfer(){
            this.$refs.orgPicker.show([],'user','transferUser')
        },
        onSave() {
            console.log('>>', this.form)
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.btnSave = true
                    this.$api.workPhoneSave(this.form).then((res) => {
                        if (res.code == 0) {
                            this.$message({ message: '修改成功', type: 'success' })
                            this.fetchData()
                        }
                    }).finally(() => {
                        this.btnSave = false
                    })
                }
            })
        },
        // 审批
        onApprove(){
            this.$refs.popApprove.show()
        },
        setApprove(e){
            console.log('审批：',e)
            this.btnApprove = true
            setTimeout(() => {
                this.btnApprove = false
                this.$message('没接口')
            }, 1000);
        },
        // 历史记录
        onHistory(){
            this.$refs.popHistory.show()
        },
        fetchData() {
            let id = this.$route.query.id
            this.form = {}
            this.$api.workPhoneDetail({id}).then(res => {
                if (res.code == 0) {
                    this.form = res.data;
                    this.hasPermission = 1
                }else if(res.code == 501){
                    this.hasPermission = 0
                }
            })
            this.$api.checkPermission([id]).then(res => { 
                if (res.code == 0) {
                    this.permission =( res.data && res.data.accountPermissionMap && res.data.accountPermissionMap[id] ) || {}
                    console.log(JSON.stringify(this.permission))
                    this.btnShow = true
                }
            })

        },
        // 复制
        onCopy(text){
            navigator.clipboard.writeText(text).then(() => {
                this.$message({ message: '复制成功', type: 'success' });
            }).catch(err => {
                this.$message.error('复制失败: ' + err);
            });
        },


    }
}
</script>

<style lang="scss" src="@/pages/assetManagement/common/style/workPhone.scss" scoped />